// endpoints and filters
export const BID_ENDPOINT = 'api/afs/bid/page';
export const BID_SAVE_ENDPOINT = 'api/afs/bid';
export const BID_DEVICE_PRICE_ENDPOINT = 'api/afs/bid/devicePrice';
export const BID_DEVICE_PRICE_GET_ENDPOINT =
  'api/afs/bid/{id}/devicePrice/page';
export const BID_OUTBOUND_FREIGHT_ENDPOINT = 'api/afs/bid/outbound';
export const BID_INBOUND_FREIGHT_ENDPOINT = 'api/afs/bid/inbound';
export const BID_OUTBOUND_FREIGHT_GET_ENDPOINT =
  'api/afs/bid/{id}/outbound/page';
export const BID_OUTBOUND_FREIGHT_IMPORT_ENDPOINT =
  'api/afs/bid/{id}/outboundFreight/file/presignedUrl';
export const BID_INBOUND_FREIGHT_GET_ENDPOINT = 'api/afs/bid/{id}/inbound/page';
export const BID_INBOUND_FREIGHT_IMPORT_ENDPOINT =
  'api/afs/bid/{id}/inboundFreight/file/presignedUrl';
export const BID_INBOUND_FREIGHT_HISTORY_ENDPOINT =
  'api/afs/bid/{id}/inbound/history';
export const BID_OUTBOUND_FREIGHT_HISTORY_ENDPOINT =
  'api/afs/bid/{id}/outbound/history';
export const BID_INVENTORY_PURCHASE_ORDER_LIST_ENDPOINT =
  'api/afs/bid/{id}/purchaseOrderSummary';
export const BID_INVENTORY_PURCHASE_ORDER_SAVE_ENDPOINT =
  '/api/afs/bid/{id}/purchaseOrder';
export const BID_INVENTORY_PURCHASE_ORDER_SAVE_TOKEN = 'purchaseOrder';
export const BID_PROCESS_FILE = 'api/afs/bid/processCsvfile';
export const BID_PROCESS_FILE_TOKEN = 'processCsvfile';

export const BID_MRC_REPORT_ENDPOINT = '/api/afs/mrcReport';
// Table Inbounds
export const DEFAULT_ROW_PER_PAGE_INBOUNDS = 10;

// Table Outbounds
export const DEFAULT_ROW_PER_PAGE_OUTBOUNDS = 10;

// ids
export const BID_TABLE_BODY_ID = 'bid_list_table_tbody';

// max lengths
export const MAX_LENGTH_BID_ID = 15;
export const MAX_LENGTH_REQUESTED_BY = 30;
export const MAX_LENGTH_END_USER_ORG = 30;
export const MAX_LENGTH_SUBMITTED_BY = 30;
export const MAX_LENGTH_VENDOR_ID = 15;
export const MAX_LENGTH_PROGRAM_REFERENCE = 30;
export const MAX_LENGTH_MRC_ID = 40;
export const MAX_LENGTH_LOCATION = 20;
export const MAX_LENGTH_DEVICE_DESCRIPTION = 60;
export const MAX_LENGTH_MPN = 30;
export const MAX_LENGTH_OUTBOUND_TRACKING_ID = 30;
export const MAX_LENGTH_OUTBOUND_FREIGHT_PROVIDER = 30;
export const MAX_LENGTH_OUTBOUND_DISPATCHED_BY = 60;
export const MAX_LENGTH_OUTBOUND_NOTES = 60;
export const MAX_LENGTH_INBOUND_TRACKING_ID = 30;
export const MAX_LENGTH_INBOUND_FREIGHT_PROVIDER = 30;
export const MAX_LENGTH_INBOUND_DISPATCHED_BY = 60;
export const MAX_LENGTH_INBOUND_NOTES = 60;
export const MAX_LENGTH_BASIC_INFORMATION_NOTES = 512;

// min lengths
export const MIN_LENGTH_DEVICE_DESCRIPTION = 4;

// mins
export const MIN_QUANTITY_DEVICES = 0;
export const MIN_OUTBOUND_NUM_ARTICLE = 1;
export const MIN_INBOUND_NUM_ARTICLE = 1;
export const MIN_INBOUND_EXPECTED_RETURN_COUNT = 0;
export const MIN_INBOUND_ACTUAL_RETURN_COUNT = 0;

// mins
export const MAX_OUTBOUND_NUM_ARTICLE = 99999;
export const MAX_INBOUND_NUM_ARTICLE = 99999;
export const MAX_INBOUND_EXPECTED_RETURN_COUNT = 99999;

// Multi-select Outbound
export const DEFAULT_ROW_PER_PAGE_MULTISELECT_OUTBOUND = 5;

/** TIME LIFE MESSAGING */
export const TIME_LIFE_MESSAGING_WARN_SAVE = 10000;

export const STATUS_CODE_PURCHARSE_CURRENTLY_PROCCESSING = 208;
